import Vue from 'vue'

const text = {}

export const storeState = Vue.observable({
  text
})
